import React from "react";
import ProjectContent from "../components/ProjectContent/ProjectContent";

const Projects = () => {
  return (
    <div>
      <ProjectContent />
    </div>
  );
};

export default Projects;
